import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useTargetGroupDataTable } from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import { TargetAvatar } from 'modules/performance_process/components/common/TargetAvatar'

interface Props {
  reviewId: number
}

const TargetGroupDataTable = ({ reviewId }: Props) => {
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()

  const source = useTargetGroupDataTable(
    [
      {
        identifier: 'target',
        title: i18n.t('performance_process.reviews.peer_management.peers_datatable.employee'),
        fixed: true,
        kind: ProjectionKind.Custom,
        template: '{{ access }}',
        colSpan: 2,
        render: ({ access }) => access && <TargetAvatar access={access} />,
      },
    ],
    {
      variables: {
        id: Number(reviewId),
        searchValue: debouncedSearch || '',
      },
    }
  )

  return (
    <DataTable.Provider
      source={source}
      pagination={{
        kind: 'offset',
        itemsPerPage: 20,
      }}
    >
      <Box gap="s16">
        <DataTable.HeadBar
          disableDefaultActions
          search={{
            placeholder: i18n.t('performance_process.reviews.target_management_search'),
            value: search,
            onChange: onSearch,
          }}
        />
        <DataTable.Table />
      </Box>
    </DataTable.Provider>
  )
}

export default TargetGroupDataTable
